import { Color, DisplayMode, Engine, FadeInOut, Vector, vec } from "excalibur";
// import { loader } from "./resources";
import { MyLevel } from "./level";
import { ShaderFactory } from './shaders/shader-factory';

// Preload WASM module early (starts loading immediately)
import './wasm-loader';

export const SCENE_NAMES = {
  START: 'start'
} as const;

// Goal is to keep main.ts small and just enough to configure the engine

const game = new Engine({
  suppressHiDPIScaling: true,
  viewport: { width: window.innerWidth, height: window.innerHeight },
  resolution: { width: window.innerWidth, height: window.innerHeight },
  displayMode: DisplayMode.FitScreen, // Display mode tells excalibur how to fill the window
  scenes: {
    [SCENE_NAMES.START]: MyLevel
  },
  // physics: {
  //   solver: SolverStrategy.Realistic,
  //   substep: 5 // Sub step the physics simulation for more robust simulations
  // },
  // fixedUpdateTimestep: 16 // Turn on fixed update timestep when consistent physic simulation is important
});

ShaderFactory.getInstance().initialize(game.graphicsContext);

const calculateExPixelConversion = (screen: ex.Screen) => {
  const origin = screen.worldToPageCoordinates(Vector.Zero);
  const singlePixel = screen.worldToPageCoordinates(vec(1, 0)).sub(origin);
  const pixelConversion = singlePixel.x;
  document.documentElement.style.setProperty('--pixel-conversion', pixelConversion.toString());
}
// Update pixel conversion on resize
game.screen.events.on('resize', () => {
  calculateExPixelConversion(game.screen);
  game.screen.pushResolutionAndViewport
});

game.start(SCENE_NAMES.START, { // name of the start scene 'start'
  // loader, // Optional loader (but needed for loading images/sounds)
  inTransition: new FadeInOut({ // Optional in transition
    duration: 100,
    direction: 'in',
    color: Color.ExcaliburBlue
  })
}).then(() => {
  calculateExPixelConversion(game.screen);
});